module.exports = {"431102001":"朝阳街道","431102002":"南津渡街道","431102003":"七里店街道","431102004":"徐家井街道","431102005":"接履桥街道","431102006":"石山脚街道","431102101":"水口山镇","431102102":"珠山镇","431102103":"黄田铺镇","431102104":"富家桥镇","431102105":"菱角塘镇","431102106":"邮亭圩镇","431102108":"石岩头镇","431102200":"大庆坪乡","431102201":"梳子铺乡","431102203":"凼底乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431102.json
// module id = 1738
// module chunks = 0